module.exports = __webpack_public_path__ + "img/window-header.f99b03ea.svg";